import reportApi from '_api/report'
import userApi from '_api/user'
import CollapseProvider from '_context/CollapseMenuContext'
import { DeviceUserContext } from '_context/DeviceUserContext'
import SelectGroupContext from '_context/SelectGroupContext'
import { DESKTOP, PHONE } from '_utils/constant'
import { setDeviceUser, setUserInfo } from '_utils/localData'
import React, { useContext, useEffect, useState } from 'react'
import ConsolidatedProvider from '../context/ConsolidatedContext'
import { ProductProvider } from '../context/ProductContext'
import Header from './components/Header'
import MainDesktop from './Main'

function AppDesktop() {
  const [loading, setLoading] = useState(true)

  const { setCheckDeviceUser } = useContext(DeviceUserContext)

  useEffect(() => {
    userApi
      .getUser()
      .then(({ msgResp }) => {
        setUserInfo(msgResp)

        const { isUsingFeature } = msgResp
        if (isUsingFeature) {
          setCheckDeviceUser(DESKTOP)
        } else {
          setDeviceUser(PHONE)
          setCheckDeviceUser(PHONE)
        }
        setLoading(false)
      })
      .catch(({ msgResp }) => {
        reportApi.report({ message: `[page desktop] ${msgResp}` })
      })
    return () => {
      setLoading({})
    }
  }, [])

  if (loading) {
    return <div>Loading...</div>
  }

  return (
    <div className='app-desktop-container'>
      <ProductProvider>
        <SelectGroupContext>
          <CollapseProvider>
            <ConsolidatedProvider>
              <Header />
              <MainDesktop />
            </ConsolidatedProvider>
          </CollapseProvider>
        </SelectGroupContext>
      </ProductProvider>
    </div>
  )
}

export default AppDesktop
